import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import styles from "./SortableItem.module.scss";
import { DragHandle } from "./DragHandle";

export function SortableItem({ id, label, desc }) {
  const {
    attributes, // accessibility attrs
    listeners, // drag listeners
    setNodeRef, // ref to draggable container
    transform,
    transition,
    isDragging,
  } = useSortable({ id,
    transition: {
    duration: 150, // milliseconds
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
  },
   });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none', // prevent native scrolling during drag
    userSelect: 'none',
    cursor: 'grab'
  };

  return (
    <div
      ref={setNodeRef}
      className={`${styles.item} ${isDragging ? styles.dragging : ""}`}
      style={style}
      tabIndex={0}
      role="listitem"
    >
      <DragHandle {...listeners} {...attributes} />
      <span className={styles.titleWrapper}>
        <div className={styles.label}>{label}</div>
        <div className={styles.desc}>{desc}</div>
      </span>
    </div>
  );
}